export default {
  useMoreAddress: 'Utilizar otra dirección',
  hideAddress: 'Plegar dirección',
  productInventory: 'Lista de mercancías',
  tag: 'Etiqueta',
  retainTag: 'Etiqueta reservada',
  delTag: 'Eliminar etiqueta',
  externalPack: 'Embalaje exterior',
  packDetail: 'Detalles de embalaje',
  postLine: 'Ruta de envío',
  selectLine: 'Seleccionar ruta',
  editLine: 'Modificar ruta',
  service: 'Servicio',
  cancelServe: 'Cancelar servicio',
  previewPackage: 'Vista previa del paquete',
  postCountry: 'País de envío',
  packageNo: 'Número de paquete',
  deliver: 'Entregar a',
  packageDetail: 'Detalles del paquete',
  addressInfo: 'Información de dirección',
  voWeight: 'Peso volumétrico',
  firstWeight: 'Peso inicial',
  continueWeight: 'Peso renovado',
  actWeight: 'Peso real',
  packageStatus: 'Estado del paquete',
  freightDetail: 'Información de costos',
  declareCurrency: 'Moneda de declaración',
  selfDeclare: 'Declaración independiente',
  packageDeclarePrice: 'Monto total de declaración del paquete',
  youPackageProduct: 'Los bienes en tu paquete',
  editYourDeclare: 'Por favor, edita tu información de declaración',
  startDeclare: 'Iniciar trámite',
  declareType: 'Tipo de declaración',
  productNo: 'ID del producto',
  declareProductPrice: 'Precio unitario declarado',
  declareTotalPrice: 'Monto total de los bienes declarados',
  editDeclare: 'Modificar declaración',
  declareLinePriceHint:
    'El monto total declarado mínimo para la ruta actual: {min}, el máximo: {max}',
  classMaxNumHint: 'El número de categorías individuales ha alcanzado el límite superior {max}',
  addDeclareProduct: 'Agregar bienes declarados',
  plsConfirmInfo: 'Por favor, confirma la información',
  wipePackProduct: 'Mercancías sin embalaje',
  foldPackProduct: 'Mercancías plegables',
  wipeTagProduct: 'Mercancías sin etiqueta',
  aboutCalcWeightExplain:
    'Como el paquete no está empaquetado en este momento, no sabemos el peso real del paquete en esta etapa, por lo que solo podemos depender de varios parámetros existentes para estimar el peso del paquete, con el fin de cobrar el depósito. Después de que el paquete esté empaquetado y se obtenga el peso real, se devolverá el excedente o se solicitará el faltante.',
  expressInfo: 'Información logística',
  deliveryMode: 'Modo de distribución',
  targetCountry: 'País de destino',
  cancelPackage: 'Cancelar paquete',
  cancelPackageHint:
    '¿Confirmas cancelar este paquete? No podrás recuperarlo después de cancelarlo.',
  isDelPackage: '¿Confirmas eliminar permanentemente el paquete?',
  delPackageHint:
    'Después de la eliminación permanente, ya no podrás ver el paquete, ¡ten cuidado!',
  receivedTips: 'Tu paquete ha sido recibido, ¡bienvenido a utilizarlo nuevamente!',
  packageQuestion: 'Hay un problema con el envío del paquete, puedes',
  afterSale: 'Solicitar servicio postventa',
  repair: 'Reembolso',
  ucan: 'Puedes',
  clickAdd: 'Haz clic en Agregar',
  addCategoryTips: 'No hay el nombre de producto que deseas declarar',
  noCarrierLines: 'No hay rutas de envío disponibles',
  confirmPackageTitle: '¿Has confirmado la recepción de los bienes?',
  confirmPackageTips:
    'Para proteger tus derechos de postventa, por favor confirma la recepción después de verificar que el paquete es correcto',
  receiptSuccess: 'Recepción exitosa',
  position: 'Posición',
  time: 'Tiempo',
  duty: 'Identificación fiscal',
  inputTrueDuty: 'Por favor, ingresa la identificación fiscal correcta',
  serveStatusEnum: {
    1: 'Fotos personalizadas',
    2: 'Extender el período de almacenamiento',
    5: 'Video Personalizado',
  },
  inputCareTime: 'Por favor, selecciona el tiempo de almacenamiento',
  holder: {
    noInputSearch: 'Número de paquete/ID del producto',
    inputEditDeclareInfo: 'Por favor, edita tu información de declaración',
    packageRemark:
      'Si tienes alguna otra solicitud especial para el paquete, por favor anótala aquí',
    yourPriceSummary: 'Resumen de tus precios',
  },
  calcFee: 'Tarifa estimada',
  realFee: 'Tarifa real',
  declare: {
    repeatDeclare: 'Tipo de declaración duplicada',
    addDeclareType: 'Por favor, agrega el tipo de declaración',
  },
  feeEnum: {
    totalAmount: 'Depósito estimado',
    deposit: 'Costo estimado',
    overLongFee: 'Tarifa por exceso de longitud',
    overWeightFee: 'Tarifa por exceso de peso',
    remoteFee: 'Tarifa de envío remoto',
    feeCustoms: 'Tarifa de gestión logística',
    feeFuel: 'Recargo por combustible',
    feeOperation: 'Tarifa de operación',
    feeService: 'Tarifa de servicio',
    valueAddedTax: 'Impuesto al valor agregado',
    insuranceService: 'Prima',
    incrementAmount: 'Tarifa de servicio adicional',
    lineDiscount: 'Descuento por ruta',
    discount: 'Descuento VIP',
    coupon: 'Selecciona un cupón',
    passwordDiscount: 'Código de descuento',
    orderPreDiscount: 'Descuento de mercancía',
    insuranceDiscount: 'Concesión de seguro',
    incrementDiscount: 'Oferta de servicio adicional',
    preVolumeCal: 'Pesaje estimado',
    actDeposit: 'Flete después del pesaje',
    actDepositAmount: 'Pago final',
  },
  ratePaymentEnum: {
    name: 'Método de pago de impuestos',
    0: 'Pagado por el destinatario',
    1: 'GST/VAT de la plataforma',
    2: 'GST/VAT personal',
    3: 'IOSS de la plataforma',
    4: 'IOSS personal',
    5: 'GST/VAT de la empresa',
    6: 'GST/VAT del proveedor logístico',
    7: 'IOSS del proveedor logístico',
    8: 'Exento de impuestos',
  },
  bagStatusEnum: {
    0: 'Paquete normal',
    1: 'Devolución nacional',
    2: 'Devolución internacional',
    3: 'Cancelado',
    4: 'Pendiente de recarga',
  },
  packageStatusEnum: {
    0: 'Esperando procesamiento',
    1: 'En proceso',
    2: 'Recogiendo',
    3: 'Recogido',
    4: 'Empaquetado completo',
    5: 'Pesado',
    6: 'Guía de remisión impresa',
    7: 'Escaneado',
    8: 'Entregado al transportista',
    9: 'Enviado',
    20: 'Recibido',
  },
  declareEnum: {
    name: 'Método de declaración',
    0: 'Declaración del sistema',
    1: 'Declaración personal',
  },
  backText: 'Volver',
  packageInformation: 'Información del paquete',
  parcelNumber: 'Número de paquete',
  noValidRule: 'El monto declarado no cumple con las reglas: {rule}',
  shippingAgree: 'Acuerdo de envío de paquetes acbuy',
  haveDiscountCode: 'Tengo un código de descuento',
  inputDiscountCode: 'Ingresa tu código de descuento aquí',
  expressNo: 'Número de seguimiento',
  shipping: 'Envío',
  taxation: 'Tributación',
  acCare: 'Cuidado ac',
  discountCode: 'Código de descuento',
  coupon: 'Cupón',
  noCouponData: 'No hay cupones que cumplan con las condiciones de descuento de envío.',
  exchange: 'Cambiar',
  rangeDeclare: 'Su importe total declarado excede el rango',
  'i18n-000001': 'Material',
  'i18n-000002': 'Color',
  'i18n-000003': 'Modelo/Talla',
  'i18n-000004': 'Material',
  'i18n-000005': 'Declarar o no',
  'i18n-000006': 'Recordatorio',
  'i18n-000007':
    'Una vez enviada, Acbuy no modificará la información de la declaración.Si la preautorización falla, procederemos con el envío.',
  'i18n-000008':
    '1. A petición de la aduana brasileña, por favor, declare el nombre del artículo, material, color, modelo / tamaño en detalle, el nombre total declarado del artículo no es superior a 5 artículos;',
  'i18n-000009':
    '2.Debido a que los paquetes pequeños de Brasil son para uso personal, cuando varios paquetes llegan al mismo tiempo a la aduana, serán retenidos. Por favor, recoja los productos múltiples por separado；',
  'i18n-000010':
    '3. Se recomienda que el paquete individual no exceda 4KG, cada declaración de bienes no es inferior a 3USD, para los productos de alto valor(máquinas de juego, teléfonos móviles, tabletas, computadoras, etc.), intente declarar lo más verosímil posible para evitar la inspección de aduanas;',
  'i18n-000011':
    '4. Estándar de impuestos locales en brasil: declare menos de 50 usd, según el impuesto ICMS 17 % +20 % de derecho, sobre 50 usd, según el impuesto ICMS 17 % +60 % de derecho, solo para referencia;',
  'i18n-000012':
    '5. Preste atención a SMS y correo electrónico cuando el paquete llegue a brasil y pague el impuesto a tiempo',
  'i18n-000013': '{ num } artículos',
  'i18n-000014': 'Nombre del producto',
  cartonWarning:
    'Su paquete es demasiado grande en tamaño o peso. Recomendamos usar una caja de cartón para lograr una mejor compresión y reducir el riesgo de daños durante el envío',
  'i18n-0000003': 'Número de paquete',
  'i18n-0000004': 'Hora de envío',
  'i18n-0000005': 'Volumen estimado ',
  'i18n-0000006': 'Peso estimado',
  'i18n-0000007': 'Costo estimado',
  'i18n-0000009': 'Nombre de la logística',
  'i18n-0000010': 'Número de seguimiento',
  'i18n-0000011': 'Pendiente de pago',
  'i18n-0000017': 'Descuento por cupón',
  'i18n-0000018': 'Dirección de entrega',
  'i18n-0000019': 'Información de declaración',
  'i18n-0000020': 'Nombre de declaración del producto',
  'i18n-0000021': 'Monto declarado($)',
  'i18n-0000022': 'Cantidad',
  'i18n-0000023': 'Subtotal($)',
  'i18n-0000024': 'Total declarado',
  'i18n-0000025': 'Información del producto',
  'i18n-0000026': 'Producto',
  'i18n-0000027': 'Peso(g)',
  'i18n-0000028': 'Volumen(cm³)',
  'i18n-0000029': 'Detalles del embalaje',
  'i18n-0000033': 'Reembolso pendiente',
  'i18n-0000034': 'Esperando el pago adicional',
  'i18n-0000035': 'Volumen real',
  'i18n-0000036': 'Peso facturado',
  'i18n-0000037': 'Costo real',
  'i18n-0000038': 'Pago real',
  'i18n-0000039': 'Fotos del paquete',
  'i18n-0000040': 'Descargar factura del paquete',
  'i18n-0000041': 'Reembolsado al saldo de la billetera',
  'i18n-0000042': 'Reemb.',
  'i18n-0000043': 'Pago adicional realizado',
  'i18n-0000046': 'Expandir',
  'i18n-0000047': 'Cerrar',
  'i18n-0000048': 'Pista logística',
  'i18n-0000049': 'Información de pesaje',
  'i18n-0000050': 'Reembolsado',
  samePreviewTips: 'Este paquete de prueba ya ha sido enviado. ¿Desea enviarlo de nuevo?',
  confirmSubmitTitle: 'Confirmar y continuar',
  confirmSubmitText: 'Please confirm your shipping address:',
  confirmSubmitContent: `Shipping Address: {address}

Important Notice: The displayed chargeable weight is an estimated value. The final billing weight will be based on the actual measured weight after packaging, usually calculated by comparing the volumetric weight and actual weight, whichever is greater. If there is any difference between the estimated and final fees, we will adjust it accordingly under the “refund or supplement” policy.`,
}
